import { render, staticRenderFns } from "./legalRisk.vue?vue&type=template&id=42813ddb&scoped=true"
import script from "./legalRisk.vue?vue&type=script&lang=js"
export * from "./legalRisk.vue?vue&type=script&lang=js"
import style0 from "./legalRisk.vue?vue&type=style&index=0&id=42813ddb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42813ddb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42813ddb')) {
      api.createRecord('42813ddb', component.options)
    } else {
      api.reload('42813ddb', component.options)
    }
    module.hot.accept("./legalRisk.vue?vue&type=template&id=42813ddb&scoped=true", function () {
      api.rerender('42813ddb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/components/legalRisk.vue"
export default component.exports